import Vue from 'vue';
export default {
  namespaced: true,
  state: {
    mainTree: [],
    sideTree: [],
    userTree: [],
    loginDialog: false,
    loading: '',
    site: ''
  },
  mutations: {
    setSite(state, payload) {
      state.site = payload;
    },
    show(state) {
      state.loading = Vue.$loading.show();
    },
    hide(state) {
      state.loading.hide();
    },
    setLoginDialog(state, payload) {
      state.loginDialog = payload;
    },
    setMainTree(state, payload) {
      state.mainTree = [...payload];
    },
    setUserTree(state, payload) {
      state.userTree = [...payload];
    },
    setSideTree(state, payload) {
      state.sideTree = [...payload];
    }
  },
  getters: {
    hasSide: state => {
      return !!state.sideTree.length;
    }
  }
};
